export function handleAutoCompleteChange(
    name: string,
    newValue: string | string[],
    setState: (value: any | ((prevState: any) => any)) => void) {
    setState((prevState) => {
        return {
            ...prevState,
            [name]: newValue
        }
    })
}

export function handleTextFieldChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    setState: (value: any | ((prevState: any) => any)) => void) {
    setState((prevState) => {
        return {
            ...prevState,
            [event.target.name]: event.target.value
        }
    })
}
